<template>
  <div>
    <el-dialog
      :visible.sync="showModel"
      width="480px"
      :show-close="false"
      :before-close="handleClose"
    >
      <div class="download-box">
        <div
          v-if="ide && ide[platform]"
          class="editor"
          :class="{'editor-active': select === 'ide'}"
          @click="select = 'ide'"
        >
          <div class="editor-select"></div>
          <img
            src="https://public-static-edu.codemao.cn/redboat/static/kitten.png"
          >
          <div class="editor-name">{{$ct('ide')}}</div>
          <p>{{ide.version}}</p>
        </div>
        <div
          v-if="wood && wood[platform]"
          class="editor"
          :class="{'editor-active': select === 'wood'}"
          @click="select = 'wood'"
        >
          <div class="editor-select"></div>
          <img src="https://public-static-edu.codemao.cn/redboat/wood.png">
          <div class="editor-name">{{$ct('wood')}}</div>
          <p>{{wood.version}}</p>
        </div>
      </div>
      <el-button class="confirm-btn" @click="downloadEditor">{{$ct('ok')}}</el-button>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['showModel'],
  data() {
    return {
      ide: null,
      wood: null,
      simpleWood: null,
      select: ''
    }
  },
  computed: {
    isWindow() {
      return this.$store.state.isWindow
    },
    os() {
      return this.$store.state.base.os
    },
    platform() {
      switch (this.os) {
        case 'Win7':
        case 'Win10':
          return 'win'
        case 'WinXP':
          return 'xp'
        case 'Mac':
          return 'mac'
      }
    }
  },
  watch: {
    showModel(val) {
      if (val) this.getDownloadUrl()
    }
  },
  methods: {
    getDownloadUrl() {
      this.getIdeUrl()
      this.getWoodUrl()
      // 海外没有精简版wood
      // this.getSimpleWoodUrl()
    },
    async getUrl(url) {
      const { status, data } = await axios.get(url, { withCredentials: false })
      return status < 400 ? data : Promise.reject(status)
    },
    async getIdeUrl() {
      const res = await this.getUrl(
        `https://static.codemao.cn/kitten/publish/kitten_editor.json?time=${+new Date()}`
      )
      this.$set(this, 'ide', {
        version: res.version,
        win: res.win.url,
        xp: res.xp.url
      })
    },
    async getWoodUrl() {
      const { version } = await this.getUrl(
        `https://static.codemao.cn/wood/oversea/client/production/latest-mac.json?time=${+new Date()}`
      )
      this.$set(this, 'wood', {
        version: `v${version}`,
        win: `https://static.codemao.cn/wood/oversea/client/production/Turtle%20Editor-${version}.exe`,
        mac: `https://static.codemao.cn/wood/oversea/client/production/Turtle%20Editor-${version}.dmg`
      })
    },
    async getSimpleWoodUrl() {
      const { version } = await this.getUrl(
        'https://static-am.codemao.cn/wood/client/xp/prod/package.json'
      )
      this.$set(this, 'simpleWood', {
        version: `v${version}`,
        xp: `https://static.codemao.cn/wood/client/xp/production/海龟编辑器(精简版)-${version}.exe`,
        win: `https://static.codemao.cn/wood/client/xp/production/海龟编辑器(精简版)-${version}.exe`
      })
    },
    handleClose() {
      this.select = ''
      this.$emit('closeModel')
    },
    downloadEditor() {
      const { select, platform } = this
      if (!select) return this.$message.error(this.$t('select'))
      const download = this[select]
      window.open(download[platform])
    }
  }
}
</script>

<style lang="scss" scoped>
.editor-content {
  margin-top: -30px;
  padding-right: 15px;
}
.download-box {
  display: flex;
  justify-content: space-between;
}
.editor {
  width: 140px;
  height: 140px;
  border-radius: 4px;
  position: relative;
  margin: auto;
  &:hover {
    cursor: pointer;
    background: rgba(245, 245, 245, 1);
  }
  padding: 10px 5px;
  img {
    width: 50px;
    height: 50px;
    display: block;
    margin: 10px auto;
  }
  p,
  .editor-name {
    margin-bottom: 5px;
    text-align: center;
  }
}
.editor-active {
  background: rgba(245, 245, 245, 1);
  .editor-select {
    display: block;
  }
}
.editor-select {
  width: 16px;
  height: 16px;
  background: url('https://public-static-edu.codemao.cn/redboat/dashboard/icn_done.png')
    no-repeat;
  background-size: cover;
  position: absolute;
  display: none;
  top: 7px;
  right: 7px;
}
.confirm-btn {
  width: 124px;
  height: 42px;
  display: block;
  font-size: 16px;
  margin: auto;
  margin-top: 26px;
  margin-bottom: 10px;
}
</style>
<i18n lang="yaml">
en:
  select: Please select the editor you want to download.
zh-CN:
  select: 请选择需要下载的编辑器
zh-TW:
  select: 請選擇需要下載的編輯器
it:
  select: Seleziona l'editor che desideri scaricare.
id:
  select: Silahkan pilih editor yang ingin diunduh
</i18n>
